module.exports = __webpack_public_path__ + "static/start-0dd3ba111daa151a4f988e99a7a67254.svg";